const upgradePersonal = {
  bannerTitle: 'HitPaw Online Ultimate',
  introduct:
    'Acesse mais de 35 recursos premium de ferramentas em todo o pacote, incluindo Enhancer, Removedor, tradutor de IA, gravador de tela e muito mais, disponíveis por um preço acessível.',
  Upgrade: 'Actualizar',
  Tools: 'Ferramentas',
  MyProjects: 'Meus Projetos',
  MyAccount: 'Minha Conta',
  Subscription: 'Inscrição',
  LogOut: 'Sair',
  PopularTools: 'Ferramentas Populares',
  Enhance: 'Melhorar',
  Remove: 'Remover',
  Animate: 'Animar',
  Extract: 'Extrair',
  SaveThreeDays:
    'Os projetos são armazenados por 3 dias, faça o download após o processamento.',
  All: 'Tudo',
  Video: 'Vídeo',
  Image: 'Imagem',
  Audio: 'Áudio',
  minutesAgo: 'minutos atrás',
  hoursAgo: 'horas atrás',
  daysAgo: 'dias atrás',
  Modified: 'Modificado',
  Order: 'Ordem',
  EarliestToLatest: 'Mais antigo para o mais recente',
  LatestToEarliest: 'Mais recente para o mais antigo',
  NoProject: 'Nenhum projeto ainda. Início rápido com',
  OnlineTools: 'Ferramentas Online',
  AIVideoEnhancer: 'Melhorador de Vídeo AI',
  Enhancer4K: 'Um clique para AI aprimorar vídeos até 4K online',
  AIPhotoEnhancer: 'AI Photo Enhancer',
  AIEnhancerImage: 'AI aprimora imagens sem perdas em até 8X online',
  View: 'Visualizar',
  Download: 'Download',
  MultipleSelect: 'Seleção múltipla',
  Delete: 'Excluir',
  SubscriptionHistory: 'Histórico de Assinaturas',
  NoValidSubscription: 'Nenhuma assinatura válida.',
  veContent: 'Um clique para AI aprimorar vídeos até 4K online',
  peContent: 'AI aprimora imagens sem perdas em até 8X online',
  rmvContent: "Remover marca d'água do vídeo",
  rmttContent: "Remova marcas d'água de vídeo TikTok em um piscar de olhos",
  dynamicContent: 'Anime sua foto online',
  rmbgContent: 'Remover fundo da imagem',
  youMayNeed: 'Você pode precisar',
  new: 'Novo',
  rather: 'Preferiria pagar o preço total de R$ 21,99/semana.',
  discountPrice: 'R$ 4,99 / 7 dias Pro',
  exclDeal: 'Nova Oferta Exclusiva!',
  endDeal: 'Pressa! Negócio termina em',
  loginYourAccount: 'Faça login na sua conta HitPaw',
  signUpYourAccount: 'Inscreva-se na sua conta HitPaw',

  HitPawWatermark: "removedor de marca d'água",
  HitPawTiktokWatermark: "Removedor de marca d'água TikTok",
  HitPawRemoveBg: 'Removedor de fundo',
  dynamicTitle: 'HitPaw Online Animar Fotos Antigas',
};
export default upgradePersonal;
